import {Document, Page, View, Font, Text, Image} from "@react-pdf/renderer";
import RubikLight from "../../../../../../fonts/Rubik-Light.ttf";
import RubikRegular from "../../../../../../fonts/Rubik-Regular.ttf";
import RubikMedium from "../../../../../../fonts/Rubik-Medium.ttf";
import RubikBold from "../../../../../../fonts/Rubik-Bold.ttf";
import RubikBlack from "../../../../../../fonts/Rubik-Black.ttf";
import {styles } from "../../StylesPdfReport";
import moment from "moment";
import CoverPage from "../../shared/pdf/CoverPage";
import AboutSection from "./AboutSection";
import Chart from "../../shared/pdf/Chart";
import ChartSubsection from "../../shared/pdf/ChartSubsection";
import Units from "../../shared/pdf/Units";
import MarkGroup from "../../shared/pdf/MarkGroup";
import TableRow from "../../shared/pdf/TableRow";
import ChartNoteWrapperBig from "../../shared/pdf/ChartNoteWrapperBig";
import {capitalize} from "@mui/material/utils";
import Html from "react-pdf-html";
import React from "react";

Font.register({
    family: "Rubik",
    format: "truetype",
    fonts: [
        { src: RubikLight, fontWeight: 300 },
        { src: RubikRegular, fontWeight: 400 },
        { src: RubikMedium, fontWeight: 500 },
        { src: RubikBold, fontWeight: 700 },
        { src: RubikBlack, fontWeight: 800 },
    ],
});

const stylesheet = {
    html: {
        fontSize: "11pt",
    },
    p: {
        fontFamily: "Rubik",
        fontWeight: 400,
        fontSize: "11pt",
        textTransform: undefined,
    },
    ul: {
        fontFamily: "Rubik",
        fontWeight: 400,
        fontSize: "11pt",
        textTransform: undefined,
    },
    li: {
        fontFamily: "Rubik",
        fontWeight: 400,
        fontSize: "11pt",
        textTransform: undefined,
    },
};

const Report = ({ reportSummary, gradeLevels, graphData }: any) => {

    return (
        <Document>
            <Page wrap size="A4" style={styles.body}>
                <View style={styles.coverBg}>
                    <CoverPage coverImage={reportSummary.coverImage} type="school">
                        <View style={styles.titleCover}>
                            <Text style={styles.h1}>Raport de evaluare</Text>
                            <Text style={styles.h2}>Sesiune #{reportSummary.testId}</Text>
                            <Text style={styles.h1}>Scor {reportSummary.score}</Text>
                            <h2> {reportSummary.studentName && `Elev: ${reportSummary.studentName}`}</h2>
                            <Text style={styles.h2}>
                                {reportSummary.testTitle !== null ? capitalize(reportSummary.testTitle) : ""}
                                {" "}
                                {reportSummary.testGradeName} |{" "}
                                {moment(reportSummary.testStartedAt).locale("ro").format("DD MMMM YYYY")}
                            </Text>
                        </View>
                    </CoverPage>
                    <View style={styles.wrapperCover}>
                        <AboutSection />
                        <View break style={styles.sectionAbout}>
                            <Text style={styles.h1}>Scorul global</Text>
                            <Chart
                                left={reportSummary.graphLeft}
                                bottom={reportSummary.graphBottom}
                                testScore={reportSummary.score}
                                segmentsImage={reportSummary.graphSegmentsImage}
                                big={true}
                                type="numericLiteracy"
                            />
                            {gradeLevels.map((gradeLevel: any, index: any) => (
                                    <View key={index}>
                                        <ChartSubsection small={false} gradeLevel={gradeLevel} score={reportSummary.score} index={index} type="numericLiteracy" />
                                    </View>
                                ))
                            }
                        </View>
                        {graphData.length > 0 &&
                            graphData.map((section: any, index: any) => (
                                <View break style={styles.sectionAbout} key={index}>
                                    <Text style={styles.h2}>Componenta {index + 1}: {section.name}</Text>
                                    <Text style={styles.p}>Medie scor: {section.score}</Text>
                                    <View style={styles.tableNote}>
                                        <View style={{ position: "relative" }}>
                                            <MarkGroup type="numericLiteracy" />
                                            <View style={styles.gradesRow}>
                                                <View style={styles.colChapter}></View>
                                                <View style={[styles.colValues, { paddingBottom: "20pt" }]}>
                                                    <Units type="numericLiteracy"/>
                                                </View>
                                            </View>
                                                <View key={index} >
                                                    <TableRow section={section} type="numericLiteracy" />
                                                </View>
                                        </View>
                                        <View style={[styles.gradesRow, { border: "none", marginTop: "7pt" }]}>
                                            <View style={styles.colChapter}></View>
                                            <View style={styles.colValues}>
                                                <View>
                                                    <Image src="/images/reports/ld/chart-tabel.png" style={styles.chartTable} />
                                                    <Units type="numericLiteracy"/>
                                                    <ChartNoteWrapperBig big={false} type="numericLiteracy" />
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                        <View key={index}>
                                            <Html style={{ fontSize: 9 }} stylesheet={stylesheet}>
                                                {section.subcategoriesDescription[index]}
                                            </Html>
                                        </View>
                                </View>
                            ))
                        }
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default Report;
